import React from 'react';
import {
    NextButtonV2,
    PrevButtonV2,
} from '../OpportunitiesCarousel/CarouselArrowButtons';

const LearnMoreCarousel = ({
    ariaLabel,
    scrollNext,
    scrollPrev,
    emblaRef,
    content,
}) => {
    return (
        <div className="md:hidden relative w-full">
            <div className="relative">
                <div
                    className="pb-6 overflow-hidden"
                    ref={emblaRef}
                    aria-label={ariaLabel}
                >
                    <div className="flex items-center  gap-4">{content}</div>
                </div>
            </div>
            <div className="flex items-center justify-center gap-6 ">
                <PrevButtonV2 onClick={scrollPrev} isMobile />
                <NextButtonV2 onClick={scrollNext} isMobile />
            </div>
        </div>
    );
};

export default LearnMoreCarousel;
